import { Controller } from "@hotwired/stimulus"

// Generic page/status polling.
//
// Default: Turbo.visit `url` (or current location) after `interval`.
// With awaitRedirect: poll JSON `{ ready, url }` and navigate with a same-window
// link click (same as StreamActions.redirect) when ready — useful as a fallback
// when a Turbo Stream redirect may be missed.
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 30000 },
    url: { type: String, default: "" },
    awaitRedirect: { type: Boolean, default: false }
  }

  connect () {
    this.redirected = false

    if (this.awaitRedirectValue) {
      this.tickStatus()
    } else {
      this.schedulePoll()
    }
  }

  disconnect () {
    this.cancelPoll()
  }

  schedulePoll () {
    this.cancelPoll()
    this.timeoutId = setTimeout(() => this.refresh(), this.intervalValue)
  }

  cancelPoll () {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  refresh () {
    const url = this.hasUrlValue ? this.urlValue : window.location.href
    Turbo.visit(url, { action: "replace" })
  }

  async tickStatus () {
    if (this.redirected || !this.hasUrlValue) return

    try {
      const res = await fetch(this.urlValue, {
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }
      })

      if (res.ok) {
        const data = await res.json()
        if (data.ready && data.url) {
          this.redirectTo(data.url)
          return
        }
      }
    } catch (_error) {
      // network blip — keep polling
    }

    this.timeoutId = setTimeout(() => this.tickStatus(), this.intervalValue)
  }

  redirectTo (url) {
    this.redirected = true
    this.cancelPoll()
    const link = document.createElement("a")
    link.href = url
    link.click()
  }
}
